var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#454545",
  d: "M14 .5H2C1.175.5.507 1.175.507 2L.5 15.5l3-3H14c.825 0 1.5-.675 1.5-1.5V2c0-.825-.675-1.5-1.5-1.5m-2.25 9h-7.5a.75.75 0 0 1-.75-.75c0-.412.337-.75.75-.75h7.5c.412 0 .75.338.75.75s-.338.75-.75.75m0-2.25h-7.5a.75.75 0 0 1-.75-.75c0-.412.337-.75.75-.75h7.5c.412 0 .75.338.75.75s-.338.75-.75.75m0-2.25h-7.5a.75.75 0 0 1-.75-.75c0-.413.337-.75.75-.75h7.5c.412 0 .75.337.75.75 0 .412-.338.75-.75.75"
})));
export default SvgSms;